import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-already-logged-in',
  templateUrl: './already-logged-in.component.html',
  styleUrls: ['./already-logged-in.component.scss']
})
export class AlreadyLoggedInComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
